<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('location.RVO') }}</h5>    
    <p class="mb-0 text-sm">{{ $t('location.Optional_information') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-4">
        <div class="col-5">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Verified') }}</label>                  
            <div class="d-block mt-1">
              <material-switch v-model="localFormData.isRvoVerified" id="isRvoVerified" name="isRvoVerified" />
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null" style="width: 150px;">
            <label class="">{{ $t('location.Verification_date') }}</label>
            <input v-model="localFormData.rvoVerificationDate" type="date" class="form-control form-control-default" :placeholder="$t('location.Verification_date')">            
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('location.Verifier') }} <small>{{ $t('location.Name_or_ID_of_the_verifier_internal_or_external') }}</small></label>
            <input v-model="localFormData.rvoVerifier" type="text" class="form-control form-control-default" :placeholder="$t('location.Verifier')">            
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('location.Verification_method') }} <small>{{ $t('location.Method_used_API_sync_manual_entry_certificate') }}</small></label>
            <input v-model="localFormData.rvoVerificationMethod" type="text" class="form-control form-control-default" :placeholder="$t('location.Verification_method')">            
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('location.Verification_source') }} <small>{{ $t('location.Source_system_eg_RVO_API_uploaded_doc') }}</small></label>
            <input v-model="localFormData.rvoVerificationSource" type="text" class="form-control form-control-default" :placeholder="$t('location.Verification_source')">            
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('location.Certificate_number') }}</label>
            <input v-model="localFormData.rvoCertificateNumber" type="text" class="form-control form-control-default" :placeholder="$t('location.Certificate_number')">            
          </div>
        </div>        
      </div>
      <div class="row mt-4">
        <div class="col-12">         
            <label class="">{{ $t('location.Notes') }}</label>            
            <textarea
              v-model="localFormData.rvoVerificationNotes"
              class="form-control custom-textarea"
              style="border: 1px solid #ced4da;"
              rows="3"
            ></textarea>
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import useVuelidate from '@vuelidate/core'
  import { reactive, watch } from 'vue'

export default {
  name: "RvoSection",
  props: {
    formData: Object,
    nextStep: Function
  },
  components: {      
    MaterialSwitch,
  },
  setup(props, { emit }) {    
    const localFormData = reactive({ ...props.formData })
    
    const v$ = useVuelidate(localFormData)

    watch(localFormData, () => {
      emit('update:formData', localFormData)
    }, { deep: true })

    const validateAndNextStep = async () => {
      v$.value.$touch() // Mark all fields as touched
      if (v$.value.$pending) {
        await v$.value.$validate() // Ensure validation completes
      }
      if (!v$.value.$invalid) {
        props.nextStep()
      }
    }

    return {
      localFormData,
      v$,
      validateAndNextStep
    }
  }
};
</script>
<style scoped>
.custom-textarea {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.5rem;  
}
</style>